import React from "react";

export const EUIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({
  ...props
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
      fill="#0052B4"
    />
    <path
      d="M10.9994 4.30469L11.3555 5.40078H12.5079L11.5756 6.07818L11.9317 7.17427L10.9994 6.49683L10.0669 7.17427L10.4231 6.07818L9.49072 5.40078H10.6432L10.9994 4.30469Z"
      fill="#FFDA44"
    />
    <path
      d="M6.26941 6.26604L7.29636 6.78922L8.11127 5.97437L7.93093 7.11261L8.95783 7.63584L7.81955 7.81614L7.63925 8.95446L7.11602 7.92755L5.97778 8.10789L6.79268 7.29299L6.26941 6.26604Z"
      fill="#FFDA44"
    />
    <path
      d="M4.30737 11.0003L5.40346 10.6442V9.4917L6.08082 10.4241L7.17696 10.068L6.49947 11.0003L7.17696 11.9327L6.08082 11.5766L5.40346 12.509V11.3565L4.30737 11.0003Z"
      fill="#FFDA44"
    />
    <path
      d="M6.26941 15.7348L6.79264 14.7078L5.97778 13.8929L7.11607 14.0733L7.63921 13.0464L7.81955 14.1847L8.95779 14.365L7.93101 14.8882L8.11126 16.0264L7.29636 15.2115L6.26941 15.7348Z"
      fill="#FFDA44"
    />
    <path
      d="M10.9994 17.6962L10.6431 16.6001H9.49072L10.4231 15.9227L10.0669 14.8267L10.9994 15.504L11.9317 14.8267L11.5756 15.9227L12.5079 16.6001H11.3555L10.9994 17.6962Z"
      fill="#FFDA44"
    />
    <path
      d="M15.7347 15.7348L14.7078 15.2116L13.8929 16.0265L14.0732 14.8882L13.0464 14.365L14.1846 14.1847L14.3649 13.0464L14.8881 14.0733L16.0264 13.8929L15.2115 14.7079L15.7347 15.7348Z"
      fill="#FFDA44"
    />
    <path
      d="M17.6988 11.0003L16.6027 11.3565V12.509L15.9253 11.5766L14.8293 11.9327L15.5067 11.0003L14.8293 10.068L15.9254 10.4241L16.6027 9.4917V10.6442L17.6988 11.0003Z"
      fill="#FFDA44"
    />
    <path
      d="M15.7347 6.26575L15.2115 7.29271L16.0264 8.10761L14.8881 7.92723L14.3649 8.95414L14.1846 7.81585L13.0464 7.63551L14.0732 7.11232L13.8929 5.97412L14.7079 6.78898L15.7347 6.26575Z"
      fill="#FFDA44"
    />
  </svg>
);
